import useConfig from '@@/use-config';
import { useEffect, useMemo } from 'react';
import { loadjs, styled, useArticle, useBook } from 'topwrite';

export default function Comment() {
    const config = useConfig();
    const id = config.getValue('siteId');
    const book = useBook();
    const article = useArticle();

    const sid = useMemo(() => {
        if (article) {
            return `${book.id}/${article.ref}`;
        }
    }, [article]);

    useEffect(() => {
        if (id && sid) {
            loadjs.ready('tqy', () => {
                window.tqy.init({
                    id,
                    source: sid,
                    container: '#qy-comment',
                    likeContainer: '#qy-like'
                });
            });
        }
    }, [id, sid]);

    return <Container id='qy-comment' />;
}

const Container = styled.div`
  margin: 1em 0;
`;
